import { UserEvent } from './user-event.model';
import { Coordinates } from '../coordinates.model';

export class DeclarationPositionRondeEvent extends UserEvent {
  public static NAME = 'POSITION_RONDE';

  constructor(
    public idVacation: string,
    public idRonde: string, // note: on devrait pas avoir besoin de l'idRonde, la vacation permet de la retrouver
    coordinates?: Coordinates
  ) {
    super(DeclarationPositionRondeEvent.NAME, undefined, coordinates);
  }

  public static hydrate(obj: DeclarationPositionRondeEvent): DeclarationPositionRondeEvent {
    return new DeclarationPositionRondeEvent(obj.idVacation, obj.idRonde, obj.coordinates);
  }
}
